<div class="container">
  <!-- First/ top group -->
  <div class="group">
    @for (condition of conditions; track condition; let i = $index; let last =
    $last) {
    <div>
      @if (i != 0) {
      <div class="and-or">{{ 'smartForms.AND' | transloco }}</div>
      }
      <div class="row conditions">
        <h3>{{ 'smartForms.IF' | transloco }}</h3>
        <select [(ngModel)]="condition.questionId" placeholder="Question ID">
          <!-- Add your question IDs here -->
          @for (question of questions; track question) {
          <option [value]="+question.questionId"
            >{{ question.questionId }} - {{question.question}}</option
          >
          }
        </select>
        <select [(ngModel)]="condition.operator">
          @for (operatorKey of getKeysOf(operators); track operatorKey) {
          <option [value]="operatorKey">{{ operators[operatorKey] }}</option>
          }
        </select>
        <!-- Add input fields for value depending on the question type -->
        <input [(ngModel)]="condition.value" placeholder="Value" />
        @if (conditions.length > 1) {
        <i
          (click)="removeCondition(i)"
          class="remove-button blue trash icon"
          style="cursor: pointer;"
        ></i>
        }
      </div>
    </div>
    }
    <!-- Add new Condition -->
    <button class="row add-condition-button" (click)="addCondition()">
      {{ 'smartForms.Add-Condition' | transloco }}
    </button>
  </div>

  <!-- Second/ middle group -->
  <div class="group">
    <div class="row">
      <h3>{{ 'smartForms.THEN' | transloco }}</h3>
      @for (actionType of actionTypes; track actionType) {
      <div style="width:100%; display:flex; flex-direction: column">
        {{actionType + ':'}}
        <div
          class="custom-select"
          (clickOutside)="this[actionType + 'Visible'] = false; searchText = ''"
        >
          <div
            class="custom-select__header"
            (click)="this[actionType + 'Visible'] = !this[actionType + 'Visible']"
          >
            {{countItemsSelected(actionType) + ' ' +
            ('smartForms.Items-Selected' | transloco)}}
          </div>
          <div
            class="custom-select__options"
            [hidden]="!this[actionType + 'Visible']"
          >
            <div class="custom-select__search">
              <input
                class="search-box"
                [(ngModel)]="searchText"
                (input)="onSearch()"
                [placeholder]="('smartForms.Search' | transloco) + '...'"
              />
            </div>
            @for (category of smartFormCategories; track category) {
            <div class="custom-select__category">
              @if (category.appearsInSearch || searchText.length == 0) {
              <div>
                <div
                  class="custom-select__category-header"
                  (click)="toggleSelection(category, actionType, 'category'); stopPropagation($event)"
                >
                  <i class="bordered colored blue tiny icons">
                    @if (category[actionType]) {
                    <i class="check colored blue big icon"></i>
                    }
                    <!-- <i *ngIf="category[actionType + 'State'] == 'some'" class="minus large blue icon"></i> -->
                  </i>
                  {{ category.id }} - {{ category.name }}
                </div>
                @for (subCategory of category.smartFormSubCategories; track
                subCategory) {
                <div class="custom-select__group">
                  @if (subCategory.appearsInSearch || searchText.length == 0) {
                  <div>
                    <div
                      class="custom-select__group-header"
                      (click)="toggleSelection(subCategory, actionType,  'subCategory'); stopPropagation($event)"
                      [ngClass]="{disabled: (!subCategory[actionType] && category[actionType])}"
                    >
                      <i class="bordered colored blue tiny icons">
                        @if (subCategory[actionType] || category[actionType]) {
                        <i
                          class="check colored big icon"
                          [ngClass]="{blue: subCategory[actionType]}"
                        ></i>
                        }
                      </i>
                      {{ subCategory.id }} - {{ subCategory.name }}
                    </div>
                    @for (question of subCategory.smartFormQuestions; track
                    question) {
                    <div
                      [ngClass]="{disabled: !question[actionType] && (category[actionType] || subCategory[actionType])}"
                      (click)="toggleSelection(question, actionType, 'question'); stopPropagation($event)"
                    >
                      @if (question.appearsInSearch || searchText.length == 0) {
                      <div class="custom-select__option">
                        <i class="bordered colored blue tiny icons">
                          @if (question[actionType] || category[actionType] ||
                          subCategory[actionType]) {
                          <i
                            class="check colored big icon"
                            [ngClass]="{blue: question[actionType]}"
                          ></i>
                          }
                        </i>
                        {{ question.questionId }} - {{ question.question }}
                      </div>
                      }
                    </div>
                    }
                  </div>
                  }
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  <div class="flex footer">
    <button class="cancel-button" (click)="cancel()">
      {{ 'smartForms.Cancel' | transloco }}
    </button>
    @if (existingLogicNode) {
    <button class="delete-button" (click)="deleteLogic()">
      {{ 'smartForms.Delete' | transloco }}
    </button>
    }

    <button
      [disabled]="!checkIfDataIsValid()"
      class="save-button flex-right"
      (click)="checkIfDataIsValid() && saveLogicData()"
    >
      {{ 'smartForms.SAVE' | transloco }}
    </button>
  </div>
</div>
